import { OverlayModule, OverlayRef } from '@angular/cdk/overlay';
import { ChangeDetectionStrategy, Component, Inject, OnInit, ViewEncapsulation } from '@angular/core';

import {
    AppInfoConfig,
    BalancePropertiesCoreService,
    CashierService,
    CommonMessages,
    DeviceService,
    ElementKeyDirective,
    ElementRepositoryService,
    EventsService,
    Logger,
    MenuItemsService,
    NativeAppService,
    NavigationService,
    Page,
    UserService,
    UtilsService,
} from '@frontend/vanilla/core';
import { QuickDepositFeatureComponent, QuickDepositMessageService } from '@payments/quickdeposit-feature';

import { CashierConfig } from '../cashier.client-config';
import { QuickDepositResponsiveComponent } from './quick-deposit-responsive.component';
import { QuickDepositOptions } from './quick-deposit.models';
import { QUICK_DEPOSIT_OPTIONS } from './quick-deposit.service';

@Component({
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [OverlayModule, ElementKeyDirective, QuickDepositFeatureComponent],
    selector: 'lh-quick-deposit-responsive-lib',
    templateUrl: './quick-deposit-lib.component.html',
    styleUrl: '../../../../../../themepark/themes/whitelabel/components/quick-deposit-lib/styles.scss',
    encapsulation: ViewEncapsulation.None,
})
export class QuickDepositLibraryComponent extends QuickDepositResponsiveComponent implements OnInit {
    constructor(
        public override deviceService: DeviceService,
        public override commonMessages: CommonMessages,
        protected override cashierService: CashierService,
        protected override elementRepositoryService: ElementRepositoryService,
        public override cashierConfig: CashierConfig,
        protected override user: UserService,
        protected override page: Page,
        protected override appInfoConfig: AppInfoConfig,
        protected override utils: UtilsService,
        protected override overlayRef: OverlayRef,
        protected override menuItemsService: MenuItemsService,
        public override quickDepositMessageService: QuickDepositMessageService,
        protected override logger: Logger,
        protected override balancePropertiesService: BalancePropertiesCoreService,
        protected override navigationService: NavigationService,
        protected override eventsService: EventsService,
        protected override nativeAppService: NativeAppService,
        @Inject(QUICK_DEPOSIT_OPTIONS) protected override options: QuickDepositOptions,
    ) {
        super(
            deviceService,
            commonMessages,
            cashierService,
            elementRepositoryService,
            cashierConfig,
            user,
            page,
            appInfoConfig,
            utils,
            overlayRef,
            menuItemsService,
            quickDepositMessageService,
            logger,
            balancePropertiesService,
            navigationService,
            eventsService,
            nativeAppService,
            options,
        );
    }

    override async ngOnInit(): Promise<void> {
        await super.ngOnInit();
    }
}
